import { render, staticRenderFns } from "./HeaderInfo.vue?vue&type=template&id=589a954d&scoped=true&"
import script from "./HeaderInfo.vue?vue&type=script&lang=js&"
export * from "./HeaderInfo.vue?vue&type=script&lang=js&"
import style0 from "./HeaderInfo.vue?vue&type=style&index=0&id=589a954d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589a954d",
  null
  
)

export default component.exports